import { createSelector } from 'reselect';
import { getSensorFeature } from '../helpers';
import { sensorFeatureKeys } from '../../../constants';
import { createErrorDataSelector } from 'selectors/selectorUtils';
import { apiCallStatus } from 'helpers/constants';

const getLoadingStatuses = ({ operationalParameters, sensorProperties }) => {
    return [operationalParameters?.collectRawDataLoadingStatus, operationalParameters?.sensorLastCommand?.loadingStatus, sensorProperties?.sensorProperties?.loadingStatus,
    sensorProperties?.sensorFeatures?.loadingStatus];
};

const getRawDataCollectionRequestFeature = ({ sensorProperties }) => {
    return getSensorFeature(sensorProperties.sensorFeatures?.data, sensorFeatureKeys.RawDataCollectionRequest);
};

const getRawDataCollectionData = ({ operationalParameters }) => {
    return operationalParameters.sensorLastCommand?.data;
};

const getSensorGatewayInfoOP = ({ sensorProperties }) => {
    return sensorProperties?.sensorGatewayInfo;
};

const getRawSensorLastCommandError = ({ operationalParameters }) => {
    if (operationalParameters?.sensorLastCommand?.loadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters.sensorLastCommand.loadingStatus,
            error: operationalParameters.sensorLastCommand.error,
            errorCode: operationalParameters.sensorLastCommand.error?.statusCode,
        };
    }
    return { loadingStatus: operationalParameters?.sensorLastCommand?.loadingStatus };
};

const getSensorLastCommandErrorData = createErrorDataSelector(getRawSensorLastCommandError);

const getRawCollectRawDataError = ({ operationalParameters }) => {
    if (operationalParameters?.collectRawDataLoadingStatus === apiCallStatus.ERROR) {
        return {
            loadingStatus: operationalParameters.collectRawDataLoadingStatus,
            error: operationalParameters.collectRawDataError,
            errorCode: operationalParameters.collectRawDataError?.statusCode,
        };
    }
    return { loadingStatus: operationalParameters?.collectRawDataLoadingStatus };
};

const getCollectRawDataErrorData = createErrorDataSelector(getRawCollectRawDataError);


const getRawDataCollectionResponseMessageFeature = ({ sensorProperties }) => {
    return getSensorFeature(sensorProperties.sensorFeatures?.data, sensorFeatureKeys.RawDataCollectionResponseMessage);
};

export const getModel = createSelector([
    getLoadingStatuses,
    getRawDataCollectionRequestFeature,
    getRawDataCollectionResponseMessageFeature,
    getRawDataCollectionData,
    getSensorGatewayInfoOP,
    getSensorLastCommandErrorData,
    getCollectRawDataErrorData,
],
    (
        loadingStatuses,
        rawDataCollectionRequest,
        rawDataCollectionResponseMessage,
        rawDataCollectionData,
        sensorGatewayInfo,
        errorData,
        collectRawDataErrorData,
    ) => {
        return {
            loadingStatuses,
            rawDataCollectionRequest,
            rawDataCollectionResponseMessage,
            rawDataCollectionData,
            sensorGatewayInfo,
            errorData,
            collectRawDataErrorData,
        };
    });
